<div style="margin-top: 25px; padding: 0px 10px;">
  <mat-spinner *ngIf="loading" diameter="70" style="margin: 50px auto 50px auto;"></mat-spinner>
  <div *ngIf="!loading">
    <!-- <span *ngIf="!logo">To use your logo in StayPrivate emails, simply upload it below. Our graphics team will check the logo then push it live. The turnaround time is normally around one business day.</span> -->
  
    <div class="logo-box">
      <mat-card-title class="title-spacer sp-title">Current logo</mat-card-title>
      <span *ngIf="!custlogo" style="margin: 10px auto">You do not currently have a logo uploaded.</span>

      <mat-card *ngIf="custlogo" class="image-card mat-elevation-z2">
        <img style="max-width: 100%; max-height: 100%;" [src]="custlogo" />
      </mat-card>
      <mat-card *ngIf="!custlogo" class="image-card mat-elevation-z2">
        <div class="dashline">
          <mat-icon class="upload-icon material-icons-outlined">cloud_upload</mat-icon>
          <span style="margin: 10px auto">Click 'Upload' to add branding</span>
        </div>
      </mat-card>

      <mat-card-title *ngIf="logo" class="title-spacer sp-title">Logo preview</mat-card-title>
      <mat-card *ngIf="logo" class="image-card mat-elevation-z2">
        <img style="max-width: 100%; max-height: 100%;" id="outImage" />
      </mat-card>

      
      <div style="display: grid; grid-auto-flow: column; align-items: center; justify-items: center;">
        <label class="custom-file-upload sp-background logo-button" *ngIf="!logo && !custlogo" style="width: 70%;">
          Upload
          <input type='file' (change)="uploadPreview($event)" [(ngModel)]="logoupload">
        </label>
  
        <button *ngIf="logo" mat-stroked-button style="color: #8f8f8f; border-color: #888; width: 70%; "
          (click)="cancelPreview()">
          Cancel
        </button>
        <button *ngIf="logo" mat-stroked-button style="color: #1A47D6; border-color: #1A47D6; width: 70%; "
          (click)="confirmPreview()">
          Confirm
        </button>  
        
        <button *ngIf="!logo && custlogo" mat-stroked-button style="color: #8f8f8f; border-color: #888; width: 70%; "
          (click)="removeLogo()">
          Remove
        </button>
        <label class="custom-file-upload sp-background logo-button" *ngIf="!logo && custlogo" style= "width: 70%;">
          Change
          <input type='file' (change)="uploadPreview($event)" [(ngModel)]="logoupload">
        </label>
      </div>    
    </div>
  </div>
</div>